module.exports = __webpack_public_path__ + "img/img_mobile_occupation_an.710ae14e.jpg";